import {
  actionCreator,
  checkHttpStatus,
  DELETE_DOCUMENTTYPES,
  GET_DOCUMENTTYPES,
  GET_DOCUMENTTYPES_BY_ID,
  jsonApiHeader,
  POST_DOCUMENTTYPES,
  documentTypeActionTypes,
  showErrorMessage,
  showSuccessMessage,
  GET_MASTERDATABYNAME,
} from '../constants/ApiConstants';
import { checkHttpStatusAuthCheck,createSearchUrlForCustomAPI } from '../../../../../actions/utilAction';


export const getMasterData = (masterData) => {    
  return (dispatch, getState) => {
      dispatch(actionCreator(documentTypeActionTypes.get_masterData.REQUEST));
      fetch(`${GET_MASTERDATABYNAME}`, {
          method: 'post',
          body: JSON.stringify(masterData),
          headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
          .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
          .then(function (response) {                
              dispatch(actionCreator(documentTypeActionTypes.get_masterData.SUCCESS, response));
          })
          .catch(function (error) {
              console.log('error getMasterData ..', error);
          });
  };
};

export const getDocumentType = (searchObj) => {

  return (dispatch, getState) => {
    dispatch(actionCreator(documentTypeActionTypes.get_documenttype.REQUEST));

    let query_params = createSearchUrlForCustomAPI(searchObj);;
    fetch(`${GET_DOCUMENTTYPES}${query_params}`, {
      method: 'GET',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        dispatch(actionCreator(documentTypeActionTypes.get_documenttype.SUCCESS, response));
      })
      .catch(function(error) {
        // errorHandler(error);
      });
  };
};

export const saveDocumentType = (formData) => {
  let postData = JSON.stringify(formData);
  return (dispatch, getState) => {
    dispatch(actionCreator(documentTypeActionTypes.post_documenttype.REQUEST));
    fetch(`${POST_DOCUMENTTYPES}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: postData,
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log(response);
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(documentTypeActionTypes.post_documenttype.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(documentTypeActionTypes.post_documenttype.FAILURE));
        }
      });
  };
};

export const deleteDocumentType = (id) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(documentTypeActionTypes.delete_documenttype.REQUEST));

    fetch(`${DELETE_DOCUMENTTYPES}?questionId=${id}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        // console.log('response.....',response)
        if (response.statusCode === 200) {
          showSuccessMessage(response.message);         
        } else {
          showErrorMessage(response.message);
        }
        dispatch(actionCreator(documentTypeActionTypes.delete_documenttype.SUCCESS, response));
      }).catch(function(error) {
        // console.log(error);
      });
  };
};
export const getDocumentTypeById = (documentTypeId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(documentTypeActionTypes.get_documenttype_by_id.REQUEST));

    fetch(`${GET_DOCUMENTTYPES_BY_ID}/${documentTypeId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        // console.log('response: ', response);
        dispatch(actionCreator(documentTypeActionTypes.get_documenttype_by_id.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error --', error);
      });
  };
};



// WEBPACK FOOTER //
// ./src/modules/Masters/components/masterDocumentTypesStaff/actions/index.js